import { setChatProvider } from '../actions/bootstrapActions';
import { getStore } from '../store/chatStore';
import ChatProvider from '../store/schema/ChatProvider';
import initializeUcma from '../ucma/chatManager/initializeUcma';
import isTeamsEnabled from '../ucwa/chatManager/isTeamsEnabled';
import getShellClientData from '../ucwa/chatManager/getShellClientData';
import initializeUcwa from '../ucwa/chatManager/initializeUcwa';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isDeepLink } from 'owa-url';
import { logUsage } from 'owa-analytics';

export default async function initializeSkypeForBusiness() {
    // We use UCMA/UCWA for chat, when
    // 1. Flight for SFB (skype for business) is enabled, and
    // 2. This is not popout window, and
    // 3. This is not consumer scenario, and
    // 4. This is not explicit logon, and
    // 5. User settings prefer UCMA than UCWA (can be overridden by flight fwk-skypeBusiness-ucmadebug)
    if (
        !isFeatureEnabled('fwk-skypeBusinessV2') ||
        isDeepLink() ||
        isConsumer() ||
        getUserConfiguration().SessionSettings.IsExplicitLogon
    ) {
        setChatProvider(ChatProvider.Disabled);
        return;
    }

    const clientData = getShellClientData();
    const store = getStore();

    if (clientData && store.chatProvider == ChatProvider.Unknown) {
        if (isFeatureEnabled('fwk-skypeBusiness-ucmadebug')) {
            setChatProvider(ChatProvider.UCMA);
        } else {
            setChatProvider(ChatProvider.Checking);

            // 1st, check the UCWA SWX override flight.
            // Then, check for teams if the user is in PROD.
            // Fall back to UCMA if all other checks fail.
            if (isFeatureEnabled('fwk-skypeBusinessV2SWX')) {
                setChatProvider(
                    clientData?.LyncIntegrationDisabled ? ChatProvider.UCMA : ChatProvider.UCWA
                );
            } else if (await isTeamsEnabled(clientData)) {
                setChatProvider(ChatProvider.Teams);
            } else {
                // Check the User Config again + Session Settings for InstantMessage enabled and Provider Ocs.
                // If both conditions not met, chat should be disabled.
                if (
                    getUserConfiguration().SegmentationSettings.InstantMessage &&
                    getUserConfiguration().PolicySettings.InstantMessagingType == 'Ocs'
                ) {
                    setChatProvider(ChatProvider.UCMA);
                    logUsage('SfB_Init_UCMA');
                } else {
                    setChatProvider(ChatProvider.Disabled);
                }
            }
        }
    }

    switch (store.chatProvider) {
        case ChatProvider.UCMA:
            initializeUcma();
            break;

        case ChatProvider.UCWA:
            initializeUcwa();
            break;
    }
}
